// src/utils/auth.ts
import { UserInfo } from "@/types/user";

const USER_KEY = "userInfo";

export const setAuthUserInfo = (user: UserInfo) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const getAuthUserInfo = (): UserInfo | null => {
  const str = localStorage.getItem(USER_KEY);
  return str ? JSON.parse(str) : null;
};

export const removeAuthUserInfo = () => {
  localStorage.removeItem(USER_KEY);
};


export const getToken = () => getAuthUserInfo()?.token || "";
export const getUid = () => getAuthUserInfo()?.uid || "";
export const getPhone = () => getAuthUserInfo()?.phone || "";
export const isAuthenticated = () => !!getToken();